import React from "react";
import { Container } from "../Components/atoms";
import { FAQArrayForChapters, MemberCard } from "../Components/organisms";

interface LBCHomePageProps {
  isLogin: boolean;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  chapterDetails?: any;
  chapterCover: React.ReactNode;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  influencers?: any[];
  NotLoggedInCard?: React.ReactNode;
}

export const LBCHomePage = ({
  isLogin,
  chapterCover,
  influencers,
  NotLoggedInCard,
  chapterDetails,
}: LBCHomePageProps) => {
  return (
    <>
      <Container>
        <div className="pb-36">
          <div className="py-[37px] md:py-11">{chapterCover}</div>
          <h2 className="font-[Inter] text-lg md:text-2xl not-italic font-semibold leading-[normal] my-5">
            Creators in the Chapter
          </h2>
          <div className="flex gap-8  flex-wrap ">
            {influencers?.map((influencer, index) => (
              <div className="w-full md:flex-1  flex flex-wrap " key={index}>
                <MemberCard
                  name={influencer?.name}
                  followers={influencer?.followers}
                  badge={influencer?.lkdBadge}
                  tagline={influencer?.tagline}
                  contentCatgories={influencer?.mappedCategories?.slice(0, 3)}
                  profileImage={influencer?.profile}
                  slug={influencer?.slug}
                  linkedinLink={influencer?.linkedinLink}
                />
              </div>
            ))}
          </div>

          {!isLogin ? NotLoggedInCard : null}

          <div className="w-full flex justify-center">
            <FAQArrayForChapters
              chapterName={chapterDetails?.title}
              className="mt-[64px] md:mt-[140px] flex flex-col items-start gap-5"
            />
          </div>
        </div>
      </Container>
    </>
  );
};
